module.exports = __webpack_public_path__ + "static/media/health.fb06bef0.png";